import type { LanguageCode } from '@kairelo/shared';
import { supportedLanguages } from '@kairelo/shared';
import { isInterfaceTranslated } from '../i18n/catalogues.js';
import { useT } from '../i18n/I18n.tsx';

/**
 * The language list, shared by owner Settings and the visitor's chat menu.
 *
 * Grouped deliberately. Every language here translates incoming messages; only
 * the first group also translates the interface. Listing them together without
 * saying so would promise coverage the product does not have.
 */
export function LanguageSelect({
  id,
  value,
  disabled,
  describedBy,
  onChange,
}: {
  id?: string;
  value: LanguageCode;
  disabled?: boolean;
  describedBy?: string;
  onChange: (language: LanguageCode) => void;
}) {
  const t = useT();
  return (
    <select
      id={id}
      aria-describedby={describedBy}
      disabled={disabled}
      value={value}
      onChange={(event) => onChange(event.target.value as LanguageCode)}
    >
      <optgroup label={t('settings.uiTranslated')}>
        {supportedLanguages
          .filter((entry) => isInterfaceTranslated(entry.code))
          .map((entry) => (
            <option key={entry.code} value={entry.code}>
              {entry.native} — {entry.label}
            </option>
          ))}
      </optgroup>
      <optgroup label={t('settings.uiEnglish')}>
        {supportedLanguages
          .filter((entry) => !isInterfaceTranslated(entry.code))
          .map((entry) => (
            <option key={entry.code} value={entry.code}>
              {entry.native} — {entry.label}
            </option>
          ))}
      </optgroup>
    </select>
  );
}
